/* eslint-disable react-hooks/exhaustive-deps */
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import 'react-datepicker/dist/react-datepicker.css'
import {useTranslation} from 'react-i18next'
import {useIntl} from 'react-intl'
import 'react-tabs/style/react-tabs.css'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {ButtonBack} from './ButtonBack'
import {ButtonSubmit} from './ButtonSubmit'
import {InputDescription} from './InputDescription'
import {InputDiscount} from './InputDiscount'
import {InputMinimumPrice} from './InputMinimumPrice'
import {InputPurchasePrice} from './InputPurchasePrice'
import {InputSellingPrice} from './InputSellingPrice'
import {SelectCities} from './SelectCities'
import {SelectProduct} from './SelectProduct'
import {SelectRegion} from './SelectRegion'
import {SelectSalesOrg} from './SelectSalesOrg'
import {SelectStatus} from './SelectStatus'
import {SelectValidFromDate} from './SelectValidFromDate'
import {SelectValidToDate} from './SelectValidToDate'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {appSelector, setJbpDetail} from '../../../../../redux/slices/appSlices'
import {useEffect} from 'react'

export const NonJBPEditPage = () => {
  const {t} = useTranslation()
  const intl = useIntl()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(setJbpDetail(null))
    }
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({
          id:
            jbp?.type === 'jbp' ? `${t('page edit harga JBP')}` : `${t('page edit harga Non JBP')}`,
        })}
      </PageTitle>

      <div className='card'>
        <div className='card-body mt-5'>
          <div>
            <Row className='mb-4'>
              <Col md={6}>
                <SelectSalesOrg />
              </Col>

              <Col md={6}>
                <SelectStatus />
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col md={6}>
                <SelectRegion />
              </Col>

              <Col md={6}>
                <SelectCities />
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col md={6}>
                <SelectProduct />
              </Col>

              <Col md={6}>
                <InputMinimumPrice />
              </Col>
            </Row>

            <Row className='mb-1'>
              <Col md={6}>
                <InputSellingPrice />
              </Col>

              <Col md={6}>
                <InputDiscount />
              </Col>
            </Row>

            <InputPurchasePrice />

            <Row className='mb-8'>
              <Col md={6}>
                <SelectValidFromDate />
              </Col>

              <Col md={6}>
                <SelectValidToDate />
              </Col>
            </Row>

            <InputDescription />

            <div className='d-flex justify-content-end'>
              <ButtonBack />
              <ButtonSubmit />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
